var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 16.22C2.66699 11.1917 2.66699 8.67751 4.22909 7.11541C5.79119 5.55331 8.30534 5.55331 13.3337 5.55331H18.667C23.6953 5.55331 26.2095 5.55331 27.7716 7.11541C29.3337 8.67751 29.3337 11.1917 29.3337 16.22C29.3337 21.2483 29.3337 23.7625 27.7716 25.3246C26.2095 26.8866 23.6953 26.8866 18.667 26.8866H13.3337C8.30534 26.8866 5.79119 26.8866 4.22909 25.3246C2.66699 23.7625 2.66699 21.2483 2.66699 16.22Z",
    stroke: "#1D1D1D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.8866L10.8785 13.2854C13.3274 15.3261 14.5518 16.3465 16 16.3465C17.4482 16.3465 18.6726 15.3261 21.1215 13.2854L24 10.8866",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.274b6f9ae7be5a39a6bc3fab9601d700.svg";